<div class="share-container" *ngIf="!loading">
  <div class="loading-container">
    <img *ngIf="imgUrl; else loadingSpinner" [src]="imgUrl" alt="Logo" class="bouncing-logo">
    <ng-template #loadingSpinner>
      <div class="loading-spinner">
        <div class="spinner"></div>
      </div>
    </ng-template>
  </div>
  <div class="share-content" *ngIf="vehicle">
    <div class="share-content-header">
      <h1>{{vehicle.make}} {{vehicle.model}} {{vehicle.trim}} {{vehicle.manufactureYear}}/{{vehicle.modelYear}}</h1>
      <p>Compartilhe este veículo da concessionária {{vehicle.oemDealerName}}</p>
      </div>
    </div>
</div>
